import { gql } from "@apollo/client";

export const GET_USER_PROFILE = gql`
query UserProfile {
    userProfile {
		id,
		name,
		userName,
		phone,
		phoneVerified,
		email,
		emailVerified,
		gender,
		bankAccountStatus,
		loginPasswordStatus,
		isActive,
		requiredPasswordChange,
		address1,
		address2,
		city,
		state,
		postcode,
		dob,
		totalBalance,
		currency,
		referralCode,
		siteUrl,
		dobUpdated,
		ua,
		currentTime,
		lastUpdated,
		affMember,
		cmRegisteredAff,
		cmActiveAff
    }
}
`;

export const GET_MAINTENANCE_LIST = gql`
query MaintenanceList {
    maintenanceList {
		providerIdList
    }
}
`;
